import styled from 'styled-components';
import { backgroundColor, menuBoxShadow } from 'styles/theme';
import { kendoPopupZIndex } from 'styles/variables';

export const FullScreenPopupContent = styled.div<{ $noPadding: boolean }>`
    z-index: ${kendoPopupZIndex};
    background: ${backgroundColor};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
`;

export type PopupContentProps = Readonly<{
    $noPadding: boolean;
}>;

export const PopupContentWrapper = styled.div`
    z-index: ${kendoPopupZIndex};
    border-radius: 0.75rem;
    box-shadow: ${menuBoxShadow};
    position: relative;
`;

export const PopupContent = styled.div<PopupContentProps>`
    border-radius: 0.75rem;
    background: ${backgroundColor};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
    position: relative;
`;
